import { ThemeColors } from "consts/theme";
import React from "react";

interface PaziaBadgeProps {
  color: ThemeColors;
  children: React.ReactNode;
  fill?: boolean;
  size?: "xs" | "sm";
  onClick?: () => void;
  className?: string;
}

const sizeClasses = {
  xs: "text-xs px-2.5 py-1",
  sm: "text-sm px-3 py-1 leading-5",
};
const colorClasses: Record<ThemeColors, string> = {
  slate: "text-slate-500 dark:text-slate-400",
  primary: "text-black-100 dark:text-primary-400",
  indigo: "text-indigo-500 dark:text-indigo-400",
  emerald: "text-emerald-500 dark:text-emerald-400",
  amber: "text-amber-500 dark:text-amber-400",
  white: "text-white dark:text-slate-100",
};
const fillClasses: Record<ThemeColors, string> = {
  slate: "bg-slate-100 dark:bg-slate-700",
  primary: "bg-primary-100 dark:bg-primary-700",
  indigo: "bg-indigo-100 dark:bg-indigo-700",
  emerald: "bg-emerald-100 dark:bg-emerald-700",
  amber: "bg-amber-100 dark:bg-amber-700",
  white: "bg-white dark:bg-slate-800",
};
export const PaziaBadge = ({ color, children, onClick, fill = true, size = "sm", className = "" }: PaziaBadgeProps) => {
  return (
    <div
      onClick={onClick}
      className={`
      ${onClick ? "cursor-pointer" : ""} ${className}
      inline-flex font-medium rounded-full ${sizeClasses[size]} 
      items-center justify-center shadow-sm duration-150 ease-in-out truncate
      border border-slate-200 dark:border-slate-700 hover:border-slate-300 dark:hover:border-slate-600
      ${fill ? `${fillClasses[color]}` : "bg-white dark:bg-slate-800"} 
      ${colorClasses[color]}`}
    >
      {children}
    </div>
  );
};
